import { isRenderedAsIframeInNewUI } from 'config';
import { AuthGuard } from 'guards';
import { IframeRouter } from 'IframeRouter';
import { lazy } from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';
import loginRoutes from './pages/auth/routes';
import { AppUrls } from 'common/constants/AppUrl';
import SiteLoadingPage from 'pages/SiteLoadingPage';

const DashboardLayout = lazy(() => import(/* webpackPrefetch: true */ 'layouts/DashboardLayout'));

const WithIframeSession = () => {
  if (isRenderedAsIframeInNewUI) {
    return (
      <IframeRouter>
        <Outlet />
      </IframeRouter>
    );
  }
  return <Outlet />;
};

export default (
  <Route element={<WithIframeSession />}>
    {!isRenderedAsIframeInNewUI && <Route path="/" element={<Navigate to="/SitePages/login" replace />} />}
    {loginRoutes}

    {isRenderedAsIframeInNewUI && (
      <Route
        path={AppUrls.SitePages.InitializationPage}
        element={
          <AuthGuard>
            <SiteLoadingPage />
          </AuthGuard>
        }
      />
    )}
    <Route
      path="/SitePages/*"
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    />
    {!isRenderedAsIframeInNewUI && <Route path="*" element={<Navigate to="/SitePages/login" replace />} />}
  </Route>
);
